module.exports = __webpack_public_path__ + "static/media/new_law_icon.79ba9a06.svg";